import type { SlateEditor } from 'platejs';
import { useEditorRef, useEditorSelection } from 'platejs/react';

/**
 * Like `useEditorRef`, but also re-renders the caller when the selection
 * changes so selection-derived UI (toolbar active state, block menus) stays
 * in sync with pure cursor movement, not just content edits.
 */
export const useContentEditor = () => {
    const editor = useEditorRef();

    useEditorSelection();

    return editor as SlateEditor;
};
